'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadStorefrontItems = exports.getLogoID = exports.getStorefrontItemIds = exports.LOAD_STOREFRONT_ITEMS_SUCCESS = exports.LOAD_STOREFRONT_ITEMS_REQUEST = exports.LOAD_STOREFRONT_ITEMS_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_STOREFRONT_ITEMS_FAIL = exports.LOAD_STOREFRONT_ITEMS_FAIL = 'la/domain/storefront/LOAD_FAIL';
var LOAD_STOREFRONT_ITEMS_REQUEST = exports.LOAD_STOREFRONT_ITEMS_REQUEST = 'la/domain/storefront/LOAD_REQUEST';
var LOAD_STOREFRONT_ITEMS_SUCCESS = exports.LOAD_STOREFRONT_ITEMS_SUCCESS = 'la/domain/storefront/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    items: [],
    loaded: {},
    loading: [],
    totalItems: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_STOREFRONT_ITEMS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                items: action.payload.items.map(function (x) {
                    return x.itemId;
                }),
                logoID: action.payload.sellers[0].logoId
            });
        case LOAD_STOREFRONT_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta)
            });
        case LOAD_STOREFRONT_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.storefront;
};
var getStorefrontItemIds = exports.getStorefrontItemIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
});
var getLogoID = exports.getLogoID = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.logoID;
});

/* ACTION CREATORS */
var loadStorefrontItems = exports.loadStorefrontItems = function loadStorefrontItems(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, authToken, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);
                            authToken = (0, _user.getAuthToken)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_STOREFRONT_ITEMS_REQUEST
                            });

                            _context.next = 7;
                            return _api.Storefront.fetchLotsBySellerId({ authToken: authToken, deployment: deployment, sellerId: sellerId });

                        case 7:
                            response = _context.sent;
                            return _context.abrupt('return', dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_STOREFRONT_ITEMS_SUCCESS
                            }));

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);
                            return _context.abrupt('return', dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_STOREFRONT_ITEMS_FAIL
                            }));

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/storefrontPage.js
// module id = 8sKG
// module chunks = 60